import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useSectionNavigation } from '../../hooks/useSectionNavigation';
import { trackEvent } from '../../analytics/tracker';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const { scrollToSection } = useSectionNavigation();

  return (
    <footer className="sw-footer" role="contentinfo">
      <div className="sw-container">
        <div className="footer-grid">
          <div className="footer-col-brand">
            <Link 
              to="/" 
              className="sw-logo"
              onClick={(e) => scrollToSection(e, 'home')}
              aria-label="Swiftech - Go to homepage"
            >
              SWIFTECH
            </Link>
            <p>{t('footer_desc')}</p>
          </div>
          
          <div className="footer-col-links">
            <h4>{t('footer_col_services')}</h4>
            <nav aria-label="Services navigation">
              <a 
                href="#services" 
                onClick={(e) => scrollToSection(e, 'services')}
              >
                {t('opt_business')}
              </a>
              <Link to="/swiftpos">{t('nav_pos')}</Link>
              <a 
                href="#services" 
                onClick={(e) => scrollToSection(e, 'services')}
              >
                {t('opt_ecommerce')}
              </a>
            </nav>
          </div>
          
          <div className="footer-col-links">
            <h4>{t('footer_col_legal')}</h4>
            <nav aria-label="Legal navigation">
              <Link to="/privacy">{t('link_privacy')}</Link>
              <Link to="/terms">{t('link_terms')}</Link>
            </nav>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>{t('copyright')}</p>
          <ul className="footer-socials" aria-label="Social media links">
            <li>
              <a 
                href="https://www.instagram.com/swiftech.lb" 
                target="_blank" 
                rel="noreferrer"
                aria-label="Follow us on Instagram"
                onClick={() => trackEvent('outbound_link', undefined, { label: 'instagram', url: 'https://www.instagram.com/swiftech.lb' })}
              >
                Instagram
              </a>
            </li>
            <li>
              <a 
                href="https://www.facebook.com/share/19QxwFmSrm/" 
                target="_blank" 
                rel="noreferrer"
                aria-label="Follow us on Facebook"
                onClick={() => trackEvent('outbound_link', undefined, { label: 'facebook', url: 'https://www.facebook.com/share/19QxwFmSrm/' })}
              >
                Facebook
              </a>
            </li>
            <li>
              <a 
                href="https://www.tiktok.com/@swiftech.lb" 
                target="_blank" 
                rel="noreferrer"
                aria-label="Follow us on TikTok"
                onClick={() => trackEvent('outbound_link', undefined, { label: 'tiktok', url: 'https://www.tiktok.com/@swiftech.lb' })}
              >
                TikTok
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
